import { DocumentIcon } from '@assets/index';
import styled from 'styled-components';

const Card = styled.article`
  flex: 1;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 30px 34px 30px 20px;
  background-color: #dae2ea;
`;

const Title = styled.p`
  color: #242424;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;

  :first-letter {
    text-transform: capitalize;
  }
`;

export const DocumentCard = ({ className = '', title }) => {
  return (
    <Card className={className}>
      <DocumentIcon className="h-14 mr-6" />
      <Title>{title}</Title>
    </Card>
  );
};
